export const prepareCleanString = string => {
  const ALLOWED_CHARACTERS_REGEX = /[^a-zA-ZāēīōūĀĒĪŌŪ0-9-]/g
  return string.replace(ALLOWED_CHARACTERS_REGEX, '')
}

export const stringContainsUnsupportedCharacters = string => {
  const cleanedString = prepareCleanString(string)
  return cleanedString.length !== string.length
}

